import Dropzone, { useDropzone } from "react-dropzone";
import { Media } from "../../interfaces/media";
import { createMedia } from "../../services/media";
import { t } from "i18next";

export interface UploaderProps {
    media: Media[];
    save: CallableFunction;
    title: string;
}

export default function Uploader(props: UploaderProps) {
    const userId = localStorage.getItem('userId');

    const {getRootProps, getInputProps} = useDropzone({
        multiple: true,
        accept: {
            'image/png': ['.png'], 'image/jpeg': ['.jpg', '.jpeg'],
            'audio/*': ['.mp3'], 'video/mp4': ['.mp4'],
            'application/pdf': ['.pdf'],
            'application/vnd.ms-powerpoint': ['.ppt'],
            'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
            'application/vnd.apple.keynote': ['.key'],
            'application/vnd.ms-excel': ['.xls'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/vnd.apple.numbers': ['.numbers'],
            'application/msword': ['.doc'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            'application/vnd.apple.pages': ['.pages'],
            'application/zip': ['.zip'], 'application/x-rar': ['.rar'], 'text/plain': ['.txt']
        }
    });

    const uploadFiles = (f: any[]) =>  {
        if (f.length > 0) {
            const formData = new FormData();
            for(let i =0; i < f.length; i++) {
                formData.append('files[]', f[i]);
            }
            createMedia(formData)
                .then(response => {
                    if (response.data !== undefined && response.data.length > 0) {
                        const newMedia = props.media.map((m: Media) => {
                            return m;
                        });
                        if (response.data.length > 0) {
                            for (let i = 0; i < response.data.length; i++) {
                                newMedia.push(response.data[i]);
                            }
                        }
                        props.save(newMedia);
                    } else {
                        alert(t("File cannot be uploaded."));
                    }
                })
                .catch((err) => console.log(err));
        }
    }

    const deleteMedia = (event: any) => {
        event.preventDefault();
        const newMedia = props.media.filter((m: Media, index) => index != event.target.dataset.position);
        props.save(newMedia);
    }

    return (
        <div className="field field-media">
            <div className="label">{ props.title }</div>
            { props.media.length > 0 &&
                <div className="media-items-list">
                    { props.media.map((m: Media, index) => {
                        switch (m.mimetype) {
                            case 'image/jpeg':
                            case 'image/png':
                                return (<div className={ 'image media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                        <img src={ m.src } alt={ m.name } height="50" />
                                        {/*<a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                        <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                        */}
                                        <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                    </div>);
                                break;
                            case 'video/mp4':
                                return (<div className={ 'video media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                            case 'audio/mpeg':
                                return (<div className={ 'audio media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                            case 'application/pdf':
                                return (<div className={ 'pdf media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                            case 'application/vnd.ms-powerpoint':
                            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                            case 'application/vnd.apple.keynote':
                                return (<div className={ 'presentation media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                            case 'application/vnd.ms-excel':
                            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                            case 'application/vnd.apple.numbers':
                                return (<div className={ 'spreadsheet media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                            case 'application/msword':
                            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                            case 'application/vnd.apple.pages':
                                return (<div className={ 'document media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                            case 'application/zip':
                            case 'application/x-rar':
                                return (<div className={ 'compress media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                            case 'text/plain':
                                return (<div className={ 'text media-item media-' + m.id } key={ 'media-item-' + m.id }>
                                    <a className="icon" href={ m.url } target="_blank" title={ m.name }></a>
                                    <a className="name" href={ m.url } target="_blank" title={ m.name }>{ m.name }</a>
                                    <button className="delete" onClick={ deleteMedia } data-position={ index } />
                                </div>);
                                break;
                        }})
                    }
                </div>
            }
            {/*files.length > 0 &&
                <div className="uploaded-files">
                    { files.map((f: any) => {
                        return (
                            <div className="image" style={ { backgroundImage: 'url(' + 'https://srv.taskgen.eu/' + f + ')' } }></div>
                        )
                    }) }
                </div>
            */}
            {<Dropzone onDrop={acceptedFiles => uploadFiles(acceptedFiles)}>
                {({getRootProps, getInputProps}) => (
                    <section>
                    <div {...getRootProps()}>
                        <input name="files" {...getInputProps()} />
                        {/* files && files.map((f: File) => {
                            return <div className="file-item">{ f.name }</div>;
                        }) */}
                        <p>{ 'Arrastra y suelta archivos aquí' }</p>
                    </div>
                    </section>
                )}
                </Dropzone> }
        </div>
    );
}
